export const DASHBOARD = "/dashboard"
export const CLIENTS = "/clients"
export const LOGIN = "/login"
export const MARKETING = "/marketing"
export const ADMINISTRATION = "/administration"
export const HOME = "/"
export const SUMMARY = "/summary"
export const PRODUCTS = "/products"
